module.exports = __webpack_public_path__ + "static/media/luoji6.accbaebd.png";